<div [formGroup]="contractBuildingCostSubsidyForm">

    <h2>{{ 'workflows.formWidgets.buildingCostSubsidy.headline' | translate }}</h2>

    <div>
        <p>
            <mat-checkbox [(ngModel)]="captureBuildingCostSubsidy" [ngModelOptions]="{standalone: true}">
                {{ 'workflows.formWidgets.buildingCostSubsidy.captureCheckbox' | translate }}
            </mat-checkbox>
        </p>
    </div>

    <ng-container *ngIf="captureBuildingCostSubsidy">


        <div fxLayout="column wrap">

            <div fxFlex="100" fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                    <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.selectFromProducts' | translate }}</mat-label>
                    <input type="text" matInput data-test="FI-Aus Produkten wählen"
                           autocomplete="new-password"
                           [formControl]="productControl"
                           [matAutocomplete]="productSelector">
                </mat-form-field>

                <mat-autocomplete #productSelector="matAutocomplete" [displayWith]="displayProductWith">
                    <mat-option *ngFor="let product of (filteredProducts$ | async)" [value]="product">
                        <span>{{ product.name }}</span>
                        <small> | {{product.price | bcmDynamicCurrency: '1.2-2'}}</small>
                    </mat-option>
                </mat-autocomplete>
            </div>

            <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.amountNet' | translate }}</mat-label>
                <input matInput
                       type="number"
                       step=".01"
                       data-test="FI-Betrag Netto"
                       formControlName="BKZ_BETRAG_NETTO"
                       autocomplete="new-password">
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.vatRate' | translate }}</mat-label>
                <input matInput
                       type="number"
                       step=".01"
                       data-test="FI-MwSt"
                       formControlName="BKZ_MWST"
                       autocomplete="new-password">
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.vatAmount' | translate }}</mat-label>
                <input matInput
                       type="number"
                       step=".01"
                       data-test="FI-MwSt Betrag"
                       formControlName="BKZ_MWST_BETRAG"
                       autocomplete="new-password">
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.netTotal' | translate }}</mat-label>
                <input matInput
                       type="number"
                       step=".01"
                       data-test="FI-Netto Gesamt"
                       formControlName="BKZ_BETRAG_GESAMT_NETTO"
                       autocomplete="new-password">
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.grossTotal' | translate }}</mat-label>
                <input matInput
                       type="number"
                       step=".01"
                       data-test="FI-Brutto Gesamt"
                       formControlName="BKZ_BETRAG_GESAMT_BRUTTO"
                       autocomplete="new-password">
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.paymentDue' | translate }}</mat-label>
                <input matInput
                       type="text"
                       data-test="FI-Zahlung fällig zum"
                       formControlName="BKZ_BETRAG_FAELLIG_ZUM"
                       autocomplete="new-password">
            </mat-form-field>


            <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.installment1' | translate }}</mat-label>
                <input matInput
                       type="text"
                       data-test="FI-Teilzahlungsbetrag 1"
                       formControlName="BKZ_TZ_1_BETRAG"
                       autocomplete="new-password">
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.installment2' | translate }}</mat-label>
                <input matInput
                       type="text"
                       data-test="FI-Teilzahlungsbetrag 2"
                       formControlName="BKZ_TZ_2_BETRAG"
                       autocomplete="new-password">
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.installment1Due' | translate }}</mat-label>
                <input matInput
                       type="text"
                       data-test="FI-Fälligkeit Teilzahlungsbetrag 1"
                       formControlName="BKZ_TZ_1_FAELLIG_ZUM"
                       autocomplete="new-password">
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.buildingCostSubsidy.installment2Due' | translate }}</mat-label>
                <input matInput
                       type="text"
                       data-test="FI-Fälligkeit Teilzahlungsbetrag 2"
                       formControlName="BKZ_TZ_2_FAELLIG_ZUM"
                       autocomplete="new-password">
            </mat-form-field>

        </div>

    </ng-container>

</div>
